import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Group, Text, TextInput } from '@mantine/core';
import BasePage from '../../BasePage';
import { Link, useLocation } from 'react-router';
import { Change, ChangeStatus, getChangeLevelLabel, getChangeStatusLabel } from '../../../interfaces/Change';
import { Grid } from '@mui/material';
import SelectionBox from '../../../components/SelectionBox';
import { IconClipboardCopy, IconExternalLink, IconLink } from '@tabler/icons-react';
import dayjs from 'dayjs';

function ChangeViewPage() {
    const location = useLocation();
    const [changeRequest, setChangeRequest] = useState<Change>();

    useEffect(() => {
        setChangeRequest(location.state.currentChange);
    });

    const parseSubmissionDate = (dateString: string): string => {
        return dayjs(dateString).format("ddd, D MMM HH:mm");
    };

    return (
        <BasePage
            breadcrumbs={[
                { label: "Change Management", previousPage: true },
                { label: `CHNG-${changeRequest?.change_id}` }
            ]}
        >
            {changeRequest ? (
                <Grid container spacing={2}>
                    <Grid size={{ sm: "grow" }}>
                        <Box style={{
                            padding: 16,
                            borderRadius: 8,
                            border: "1px solid var(--border-color)"
                        }}>
                            <Text fw="450">{changeRequest?.title}</Text>
                            <Text fz="0.9rem" c="var(--text-dimmed)">{`Hazem on ${parseSubmissionDate(changeRequest.created_at)}`}</Text>
                            
                            <Divider my="md" />
                            
                            <Text>{changeRequest.description}</Text>
                        </Box>

                        <Box mt="md">
                            <TextInput
                                label="Associated Ticket"
                                description="Paste the link to the associated Zoho Ticket"
                                leftSection={<IconLink size="1.25rem" />}
                            />

                            <Group gap={4} mt="xs">
                                <Button
                                    className="unify-btn-subtle"
                                    leftSection={<IconClipboardCopy size={"1.25rem"} />}>
                                    Copy
                                </Button>

                                <Button className="unify-btn-subtle"
                                    leftSection={<IconExternalLink size={"1.25rem"} />}>
                                        Open
                                </Button>
                            </Group>
                        </Box>
                    </Grid>
                    <Grid size={{ sm: "auto" }}>
                        <Box style={{
                            width: "100%",
                            border: "1px solid var(--border-color)",
                            borderRadius: 8,
                            padding: 8
                        }}>
                            <table>
                                <tr>
                                    <td>
                                        <Text c="var(--text-dimmed)">Status</Text>
                                    </td>
                                    <td>
                                        <Text ml="md">{getChangeStatusLabel(changeRequest.status)}</Text>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <Text c="var(--text-dimmed)">Priority</Text>
                                    </td>
                                    <td>
                                        <Text ml="md">{getChangeLevelLabel(changeRequest.priority)}</Text>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <Text c="var(--text-dimmed)">Approval</Text>
                                    </td>
                                    <td>
                                        <Group ml="md" gap={6}>
                                            <Link className="unify-link" to="#">Approve</Link>
                                            <Text>/</Text>
                                            <Link className="unify-link" to="#">Reject</Link>
                                        </Group>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <Text c="var(--text-dimmed)">Start Date</Text>
                                    </td>
                                    <td>
                                        <Text ml="md">{
                                                new Date(changeRequest.implementation_date).toLocaleDateString()
                                            }</Text>
                                    </td>
                                </tr>
                            </table>
                        </Box>

                        <Box style={{
                            width: "100%",
                            border: "1px solid var(--border-color)",
                            borderRadius: 8,
                            padding: 8
                        }}
                            mt="md"
                        >
                            <SelectionBox values={[
                                "Closed",
                                "Open",
                                "On Hold",
                                "Awaiting Approval",
                                "In Progress",
                                "Testing"
                            ]}
                                label="Status"
                                defaultValue={getChangeStatusLabel(changeRequest?.status ?? ChangeStatus.Closed)}
                            />
                        </Box>
                    </Grid>
                </Grid>
            ) : (
                <Text>Loading...</Text>
            )}
        </BasePage>
    )
};

export default ChangeViewPage;